import React, {Component, useRef} from 'react'
import moment from "moment";
//redux
import { connect } from "react-redux";
import { getActivityData } from "../VoteActivity/store/actionCreators";
import { GET_USER_INFO_DATA } from "../User/store/actionTypes";
//样式
import {
    WagesCheckContainer
} from "./style";

//antd
import { TextArea,Space,Input } from 'antd-mobile';
import { List } from 'antd';

import $axios from "../../request";
import CreationChartItem from "../../components/CreationChartItem";

class ActivityDescription extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sortTypeEnum:{default: 'default',vote: 'vote',time: 'time',},
            sortType:"default",
            loading: true,
            voteBriefing: '',
            subStartTime: '',
            subEndTime: '',
            sponsor: '',
            voteRules: ''
        }
    }


    componentDidMount() {
        const {activityList} = this.props;
        let activity = {};
        if(activityList&&activityList.length>0){
            activity = activityList[0];
        }

        let startTime = '';
        let endTime = '';
        if(activity.subStartTime!=undefined&&activity.subStartTime!=''){
            startTime =  moment(activity.subStartTime).format('YYYY年MM月DD日');
            endTime = moment(activity.subEndTime).format('YYYY年MM月DD日');
        }
        this.setState({
            voteBriefing: activity.voteBriefing,
            subStartTime: startTime,
            subEndTime: endTime,
            sponsor: activity.sponsor,
            voteRules: activity.voteRules
        });
    }
    handleFun(to) {
        to+='?&time='+Date.parse(new Date())
        this.props.history.push(to)
    }

    render() {
        //let { voteBriefing,subStartTime,subEndTime,sponsor,voteRules } = this.state;
        const {activityList} = this.props;
        let activity = {};
        if(activityList&&activityList.length>0){
            activity = activityList[0];
        }

        let startTime = '';
        let endTime = '';
        if(activity.subStartTime!=undefined&&activity.subStartTime!=''){
            startTime =  moment(activity.subStartTime).format('YYYY年MM月DD日');
            endTime = moment(activity.subEndTime).format('YYYY年MM月DD日');
        }
        console.log("activity",activity)
        return (

            <WagesCheckContainer>

                <div className="container">
                    <img src='https://zhihuigonghui.oss-cn-beijing.aliyuncs.com/voteActivity/WechatIMG49.jpeg' style={{width: "100%"}} alt="" />
                    <div className="container2">
                        <Space block direction='vertical' >
                            <div className="titleText marginTop16">活动简介</div>
                        </Space>
                        <br/>
                        <Space block direction='vertical' >
                            <TextArea  autoSize value={"  "+activity.voteBriefing} className="textContent" disabled/>
                        </Space>
                        <br/>
                        <Space block direction='vertical' >
                            <div className="titleText marginTop16">活动时间</div>
                        </Space>
                        <br/>
                        <Space block direction='vertical' >
                            <TextArea rows={1} value={"  "+startTime+'-'+endTime} className="textContent" disabled/>
                        </Space>
                        <br/>
                        <Space block direction='vertical' >
                            <div className="titleText marginTop16">主办单位</div>
                        </Space>
                        <br/>
                        <Space block direction='vertical' >
                            <TextArea rows={1} value={"  "+activity.sponsor} className="textContent" disabled/>
                        </Space>
                        <br/>
                        <Space block direction='vertical' >
                            <div className="titleText marginTop16">活动规则</div>
                        </Space>
                        <br/>
                        <Space block direction='vertical' >
                            <TextArea autoSize='true' value={"  "+activity.voteRules} className="textContent" disabled/>
                        </Space>
                    </div>
                </div>
            </WagesCheckContainer>

        )
    }
}

const mapState = state => {

    return {
        activityList:state.getIn(['activity', 'activity'])
    }

}
const mapDispatch = dispatch => {
    return {

        _getActivityData(data) {

            dispatch(getActivityData(data))
        }
    }
}


export default connect(mapState, mapDispatch)(ActivityDescription)
